<template>
  <div class="row">
    <b-container fluid>
      <b-card no-body>
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <div class="m-2">
            <!-- Tabs Switch -->
            <b-row class="align-items-center mt-1">
              <b-col cols="12">
                <div class="tab-switch">
                  <button
                    type="button"
                    class="tab-btn"
                    :class="{ active: activeTab === 0 }"
                    @click="activeTab = 0; onTabChange(0)"
                  >
                    <feather-icon icon="TagIcon" size="14" class="mr-50" />
                    1. Loại khoản thu
                  </button>
                  <button
                    type="button"
                    class="tab-btn"
                    :class="{ active: activeTab === 1 }"
                    @click="activeTab = 1; onTabChange(1)"
                  >
                    <feather-icon icon="DollarSignIcon" size="14" class="mr-50" />
                    2. Khoản thu
                  </button>
                  <button
                    type="button"
                    class="tab-btn"
                    :class="{ active: activeTab === 2 }"
                    @click="activeTab = 2; onTabChange(2)"
                  >
                    <feather-icon icon="FileTextIcon" size="14" class="mr-50" />
                    3. Kế hoạch thu
                  </button>
                  <button
                    type="button"
                    class="tab-btn"
                    :class="{ active: activeTab === 3 }"
                    @click="activeTab = 3; onTabChange(3)"
                  >
                    <feather-icon icon="PercentIcon" size="14" class="mr-50" />
                    4. Khoản miễn giảm
                  </button>
                  <button
                    type="button"
                    class="tab-btn"
                    :class="{ active: activeTab === 4 }"
                    @click="activeTab = 4; onTabChange(4)"
                  >
                    <feather-icon icon="CalendarIcon" size="14" class="mr-50" />
                    5. Dự kiến thu
                  </button>
                </div>
              </b-col>
            </b-row>

            <!-- Tab Content -->
            <b-tabs v-model="activeTab" class="content-tabs my-tabs mt-2" @input="onTabChange">
              <!-- Tab 1: Loại khoản thu -->
              <b-tab key="revenue-type">
                <RevenueType ref="revenueTypeRef" @data-updated="onChildDataUpdated" />
              </b-tab>

              <!-- Tab 2: Khoản thu -->
              <b-tab key="revenue">
                <Revenue ref="revenueRef" @data-updated="onChildDataUpdated" />
              </b-tab>

              <!-- Tab 3: Kế hoạch thu -->
              <b-tab key="revenue-plan">
                <RevenuePlan ref="revenuePlanRef" @data-updated="onChildDataUpdated" />
              </b-tab>

              <!-- Tab 4: Khoản miễn giảm -->
              <b-tab key="exemption">
                <Exemption ref="exemptionRef" @data-updated="onChildDataUpdated" />
              </b-tab>

              <!-- Tab 5: Dự kiến thu -->
              <b-tab key="revenue-schedule">
                <b-row>
                  <b-col cols="12">
                    <b-form-group
                      label="Bộ lọc"
                      class="border border-primary rounded p-50"
                      label-class="pb-25"
                    >
                      <b-row>
                        <b-col cols="12" md="6" lg="6" xl="6">
                          <b-form-group
                            label-for="scheduleTrainingSystemsSelected"
                          >
                            <v-select
                              v-model="scheduleTrainingSystemsSelected"
                              :options="scheduleTrainingSystemsOptions"
                              :reduce="option => option.value"
                              label="label"
                              placeholder="Loại hình đào tạo"
                              @input="onChangeScheduleTrainingSystems"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6" lg="6" xl="6">
                          <b-form-group
                            label-for="scheduleCoursesSelected"
                          >
                            <v-select
                              v-model="scheduleCoursesSelected"
                              :options="scheduleCoursesOptions"
                              :reduce="option => option.value"
                              label="label"
                              placeholder="Khóa học"
                              @input="onChangeScheduleCourses"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6" lg="6" xl="6">
                          <b-form-group
                            label-for="scheduleSemestersSelect"
                          >
                            <v-select
                              v-model="scheduleSemestersSelect"
                              :options="scheduleSemestersOptions"
                              :reduce="option => option.value"
                              label="label"
                              placeholder="Kỳ học"
                              @input="onChangeScheduleSemesters"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6" lg="6" xl="6">
                          <b-form-group
                            label-for="scheduleMajorsSelect"
                          >
                            <v-select
                              v-model="scheduleMajorsSelect"
                              :options="scheduleMajorsOptions"
                              :reduce="option => option.value"
                              label="label"
                              placeholder="Ngành"
                              @input="onChangeScheduleMajors"
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <div class="text-right mb-2">
                      <b-button
                        v-show="currentRevenueSchedule.course_semester_id > 0"
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="success"
                        class="ml-1"
                        @click="onCreateAll"
                      >
                        <feather-icon icon="PlusIcon" size="14" class="mr-50" />
                        <span class="text-nowrap text-right">Tạo dự kiến toàn bộ kỳ học</span>
                      </b-button>
                      <b-button
                        v-show="countRP >= 0 && revenueScheduleCreatable"
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="success"
                        class="ml-1"
                        @click="onCreateKTK"
                      >
                        <feather-icon icon="PlusIcon" size="14" class="mr-50" />
                        <span class="text-nowrap text-right">Tạo mới khoản thu khác</span>
                      </b-button>
                      <b-button
                        v-show="countRP >= 0 && revenueScheduleCreatable"
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="success"
                        class="ml-1"
                        @click="onCreate"
                      >
                        <feather-icon icon="PlusIcon" size="14" class="mr-50" />
                        <span class="text-nowrap text-right">Tạo mới học phí</span>
                      </b-button>
                      <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="primary"
                        class="ml-1"
                        @click="onSelect"
                      >
                        <feather-icon icon="ListIcon" size="14" class="mr-50" />
                        <span class="text-nowrap text-right">Danh sách</span>
                      </b-button>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col cols="12">
                    <vue-good-table
                      mode="remote"
                      :columns="scheduleColumns"
                      :rows="revenueSchedules"
                      :pagination-options="paginationOptions"
                      :total-rows="scheduleTotalRows"
                      :line-numbers="true"
                      @on-page-change="onSchedulePageChange"
                      @on-per-page-change="onSchedulePerPageChange"
                    >
                      <div
                        slot="emptystate"
                        style="text-align: center; font-weight: bold"
                      >
                        Không có bản ghi nào !
                      </div>
                      <template
                        slot="table-row"
                        slot-scope="props"
                      >
                        <span v-if="props.column.field === 'stt'">
                          {{ props.row.originalIndex + 1 }}
                        </span>
                        <span v-else-if="props.column.field === 'is_exemption'">
                          {{ props.row.status === 1 ? 'Có' : 'Không' }}
                        </span>
                        <span v-else-if="props.column.field === 'action'">
                          <b-button
                            v-if="revenueScheduleUpdatable"
                            v-b-modal.revenueScheduleSaveModal
                            variant="primary"
                            class="btn-icon"
                            size="sm"
                            @click="onEditRevenueSchedule(props.row)"
                          >
                            <feather-icon icon="Edit2Icon" />
                          </b-button>
                          <b-button
                            v-if="revenueScheduleDeletable"
                            variant="danger"
                            class="btn-icon"
                            style="margin-left: 6px"
                            size="sm"
                            @click="props.row.price == null ? onDeleteRevenueKTKSchedule(props.row) : onDeleteRevenueSchedule(props.row)"
                          >
                            <feather-icon icon="TrashIcon" />
                          </b-button>
                        </span>
                        <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                      </template>
                      <template
                        slot="pagination-bottom"
                        slot-scope="props"
                      >
                        <div class="d-flex justify-content-between flex-wrap">
                          <div class="d-flex align-items-center mb-0 mt-1">
                            <span class="text-nowrap"> Hiển thị {{ scheduleFilter.itemsPerPage * (scheduleFilter.currentPage-1) +1 }}
                              đến {{ (scheduleFilter.itemsPerPage * (scheduleFilter.currentPage) >= scheduleTotalRows)? scheduleTotalRows : scheduleFilter.itemsPerPage * (scheduleFilter.currentPage) }} &nbsp; của {{ scheduleTotalRows }} bản ghi
                            </span>
                          </div>
                          <div class="d-flex align-items-center mb-0 mt-1">
                            <span class="text-nowrap"> Hiển thị </span>
                            <b-form-select
                              v-model="scheduleFilter.itemsPerPage"
                              :options="itemsPerPageOptions"
                              class="mx-1"
                              @input="(value) => props.perPageChanged({ currentPerPage: value })"
                            />
                            <span class="text-nowrap"> bản ghi/trang</span>
                          </div>
                          <div>
                            <b-pagination
                              :value="1"
                              :total-rows="scheduleTotalRows"
                              :per-page="scheduleFilter.itemsPerPage"
                              class="mt-1 mb-0"
                              @input="(value) => props.pageChanged({ currentPage: value })"
                            />
                          </div>
                        </div>
                      </template>
                    </vue-good-table>
                  </b-col>
                </b-row>
              </b-tab>
            </b-tabs>
          </div>
        </b-overlay>
      </b-card>
    </b-container>

    <!-- Modals -->
    <revenueScheduleSave
      ref="revenueScheduleSaveFormRef"
      :revenue-schedule="currentRevenueSchedule"
      @succeed="onRevenueScheduleSucceed"
    />
  </div>
</template>

<script>
import {
  BButton, BCard, BCol, BContainer, BFormGroup, BFormSelect, BOverlay, BPagination, BRow, BTabs, BTab,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import { mapActions, mapGetters } from 'vuex'
import { showSuccessToast, showErrorToast } from '@/utils/notification'
import '@core/scss/vue/libs/vue-good-table.scss'
import Ripple from 'vue-ripple-directive'
import RevenueType from '@/views/admin/category/revenuetype/RevenueType.vue'
import Revenue from '@/views/finance/revenue/Revenue.vue'
import RevenuePlan from '@/views/finance/revenue-plan/RevenuePlan.vue'
import Exemption from '@/views/finance/exemption/Exemption.vue'
import revenueScheduleSave from '@/views/finance/revenue-schedule/RevenueScheduleSave.vue'
import vSelect from 'vue-select'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import { PermissionCode, ResourceCode } from '@/const/code'
import { getUser } from '@/auth/utils'

export default {
  name: 'RevenueSchedule',
  directives: {
    Ripple,
  },
  components: {
    RevenueType,
    Revenue,
    RevenuePlan,
    Exemption,
    revenueScheduleSave,
    BFormGroup,
    BButton,
    BCard,
    BCol,
    BContainer,
    BFormSelect,
    BOverlay,
    BPagination,
    BRow,
    BTabs,
    BTab,
    VueGoodTable,
    vSelect,
  },
  data() {
    return {
      activeTab: 0,
      isLoading: false,
      itemsPerPageOptions: [10, 20, 30, 50, 80, 100],
      paginationOptions: {
        enabled: true,
      },

      // Revenue Schedule Data
      scheduleTrainingSystemsSelected: undefined,
      scheduleCoursesSelected: undefined,
      scheduleSemestersSelect: undefined,
      scheduleMajorsSelect: null,
      countRP: 0,
      countRS: 0,
      scheduleFilter: {
        currentPage: 1,
        itemsPerPage: 10,
        organization_id: getUser().orgId,
        course_semester_id: null,
        major_id: null,
      },
      currentRevenueSchedule: {
        revenue_plan_id: null,
        price: null,
        start_at: null,
        end_at: null,
        course_semester_id: null,
        id: null,
        major_id: null,
      },
      scheduleColumns: [
        {
          label: 'Loại khoản thu',
          field: 'revenue_type_name',
          filterOptions: {
            enabled: false,
            trigger: 'enter',
          },
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Tên khoản thu',
          field: 'revenue_name',
          filterOptions: {
            enabled: false,
            trigger: 'enter',
          },
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Bắt đầu',
          field: 'start_at',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Kết thúc',
          field: 'end_at',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Kỳ học',
          field: 'semester_name',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Ngành',
          field: 'major_name',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Miễn giảm',
          field: 'is_exemption',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Ngày tạo',
          field: 'created_at',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Thao tác',
          field: 'action',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      revenueSchedules: 'revenueSchedule/revenueSchedules',
      scheduleTotalRows: 'revenueSchedule/totalRows',
      scheduleTrainingSystems: 'revenueSchedule/allTrainingSystems',
      scheduleMajors: 'revenueSchedule/allMajors',
      scheduleCourses: 'revenueSchedule/listCourses',
      scheduleSemesters: 'revenueSchedule/listSemesters',
      statusRevenueSchedule: 'revenueSchedule/statusRevenueSchedule',
    }),
    scheduleTrainingSystemsOptions() {
      return this.scheduleTrainingSystems.map(item => ({ value: item.id, label: item.name }))
    },
    scheduleCoursesOptions() {
      return this.scheduleCourses.map(item => ({ value: item.id, label: item.name }))
    },
    scheduleSemestersOptions() {
      return this.scheduleSemesters.map(item => ({ value: item.id, label: item.name }))
    },
    scheduleMajorsOptions() {
      return this.scheduleMajors.map(item => ({ value: item.id, label: item.name }))
    },
    revenueScheduleCreatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.CREATE, ResourceCode.REVENUE_SCHEDULE)
    },
    revenueScheduleUpdatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.REVENUE_SCHEDULE)
    },
    revenueScheduleDeletable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.DELETE, ResourceCode.REVENUE_SCHEDULE)
    },
  },
  async created() {
    this.isLoading = true
    try {
      await this.beginRevenueSchedule()
    } catch (e) {
      showErrorToast(this, e)
    } finally {
      this.isLoading = false
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.hideTabTitles()
      // Load data for the first tab when component is mounted
      if (this.activeTab === 0 && this.$refs.revenueTypeRef) {
        if (this.$refs.revenueTypeRef.refreshData) {
          this.$refs.revenueTypeRef.refreshData()
        }
      }
    })
  },
  methods: {
    hideTabTitles() {
      const myTabs = document.querySelector('.my-tabs')
      if (myTabs) {
        const navTabs = myTabs.querySelectorAll('.nav-tabs, .nav, ul.nav-tabs, ul.nav')
        navTabs.forEach(nav => {
          if (nav) {
            nav.style.display = 'none'
          }
        })
        const navItems = myTabs.querySelectorAll('.nav-item, .nav-link')
        navItems.forEach(item => {
          if (item) {
            item.style.display = 'none'
          }
        })
      }
    },
    async onTabChange(tabIndex) {
      this.activeTab = tabIndex
      // Refresh data when switching tabs
      await this.$nextTick()
      try {
        if (tabIndex === 0 && this.$refs.revenueTypeRef) {
          // Tab 1: Loại khoản thu - load data when tab is activated
          if (this.$refs.revenueTypeRef.refreshData) {
            await this.$refs.revenueTypeRef.refreshData()
          }
        } else if (tabIndex === 1 && this.$refs.revenueRef) {
          // Tab 2: Khoản thu - refresh để lấy loại khoản thu mới và revenue list
          if (this.$refs.revenueRef.refreshData) {
            await this.$refs.revenueRef.refreshData()
          }
        } else if (tabIndex === 2 && this.$refs.revenuePlanRef) {
          // Tab 3: Kế hoạch thu - refresh để lấy khoản thu mới
          if (this.$refs.revenuePlanRef.refreshData) {
            await this.$refs.revenuePlanRef.refreshData()
          }
        } else if (tabIndex === 3 && this.$refs.exemptionRef) {
          // Tab 4: Khoản miễn giảm - refresh để lấy dữ liệu mới
          if (this.$refs.exemptionRef.refreshData) {
            await this.$refs.exemptionRef.refreshData()
          }
        }
        // Tab 5: Dự kiến thu - không cần refresh vì đã có logic riêng
      } catch (e) {
        // Silently handle errors
        console.error('Error refreshing tab data:', e)
      }
    },
    ...mapActions({
      beginRevenueSchedule: 'revenueSchedule/begin',
      getRevenueSchedules: 'revenueSchedule/getRevenueSchedules',
      getScheduleCourses: 'revenueSchedule/getCourses',
      getScheduleSemesters: 'revenueSchedule/getSemesters',
      getCountRevenueSchedule: 'revenueSchedule/getCountRevenueSchedule',
      createRevenueSchedule: 'revenueSchedule/createRevenueSchedule',
      createRevenueScheduleKTK: 'revenueSchedule/createRevenueScheduleKTK',
      createAllRevenueSchedule: 'revenueSchedule/createAllRevenueSchedule',
      deleteRevenueSchedule: 'revenueSchedule/deleteRevenueSchedule',
      deleteRevenueKTKSchedule: 'revenueSchedule/deleteRevenueKTKSchedule',
    }),
    // Revenue Schedule Methods
    async onCreate() {
      this.isLoading = true
      try {
        const response = await this.createRevenueSchedule({ courses_semester_id: this.currentRevenueSchedule.course_semester_id, major_id: this.currentRevenueSchedule.major_id })
        if (response.isSuccessful) {
          showSuccessToast(this, response.message)
        } else {
          showErrorToast(this, response.message)
        }
        if (response.isSuccessful) {
          this.countRS = 1
          await this.onSelect()
        }
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    async onCreateKTK() {
      this.isLoading = true
      try {
        const response = await this.createRevenueScheduleKTK({ courses_semester_id: this.currentRevenueSchedule.course_semester_id })
        if (response.isSuccessful) {
          showSuccessToast(this, response.message)
        } else {
          showErrorToast(this, response.message)
        }
        if (response.isSuccessful) {
          this.countRS = 1
          await this.onSelect()
        }
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    async onCreateAll() {
      this.isLoading = true
      try {
        const response = await this.createAllRevenueSchedule({ courses_semester_id: this.currentRevenueSchedule.course_semester_id })
        if (response.isSuccessful) {
          showSuccessToast(this, response.message)
        } else {
          showErrorToast(this, response.message)
        }
        this.resetRevenueSchedule()
        this.countRP = 0
        this.countRS = 0
        if (this.scheduleMajorsSelect != null) {
          await this.getCountRevenueSchedule({
            course_semester_id: this.scheduleFilter.course_semester_id,
            major_id: this.scheduleMajorsSelect,
          })
          this.countRP = this.statusRevenueSchedule[0].count_rp
          this.countRS = this.statusRevenueSchedule[0].count_rs
          if (this.countRP === 0) {
            showErrorToast(this, 'Chưa có kế hoạc thu của ngành trong học kỳ này')
          }
        }
        if (response.isSuccessful) {
          await this.onSelect()
        }
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    async onSelect() {
      this.isLoading = true
      try {
        await this.getRevenueSchedules(this.scheduleFilter)
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    onChangeScheduleTrainingSystems() {
      if (this.scheduleTrainingSystemsSelected == null) {
        this.resetRevenueSchedule()
        this.$store.commit('revenueSchedule/SET_COURSES', { data: [] })
        this.$store.commit('revenueSchedule/SET_SEMESTERS', { data: [] })
        this.scheduleCoursesSelected = null
        this.scheduleSemestersSelect = null
        this.currentRevenueSchedule.course_semester_id = null
      } else {
        this.currentRevenueSchedule.training_system_id = this.scheduleTrainingSystemsSelected
        this.getScheduleCourses({
          training_system_id: this.scheduleTrainingSystemsSelected,
        })
      }
    },
    onChangeScheduleCourses() {
      if (this.scheduleCoursesSelected == null) {
        this.resetRevenueSchedule()
        this.$store.commit('revenueSchedule/SET_SEMESTERS', { data: [] })
        this.scheduleSemestersSelect = null
        this.currentRevenueSchedule.course_semester_id = null
      } else {
        this.currentRevenueSchedule.course_id = this.scheduleCoursesSelected
        this.scheduleFilter.course_id = this.scheduleCoursesSelected
        this.getScheduleSemesters({
          courses_id: this.scheduleCoursesSelected,
        })
      }
    },
    onChangeScheduleSemesters() {
      if (this.scheduleSemestersSelect == null) {
        this.resetRevenueSchedule()
        this.currentRevenueSchedule.course_semester_id = null
      } else {
        this.currentRevenueSchedule.semester_id = this.scheduleSemestersSelect
        this.scheduleFilter.semester_id = this.scheduleSemestersSelect
        const item = this.scheduleSemesters.find(x => x.id === this.scheduleSemestersSelect)
        if (item) {
          this.currentRevenueSchedule.course_semester_id = item.courses_semesters_id
          this.scheduleFilter.course_semester_id = item.courses_semesters_id
        }
      }
    },
    async onChangeScheduleMajors() {
      this.currentRevenueSchedule.major_id = this.scheduleMajorsSelect
      if (this.scheduleMajorsSelect == null) {
        this.resetRevenueSchedule()
        this.scheduleFilter.major_id = null
        this.countRP = 0
        this.countRS = 0
      } else {
        this.scheduleFilter.major_id = this.scheduleMajorsSelect
        await this.getCountRevenueSchedule({
          course_semester_id: this.scheduleFilter.course_semester_id,
          major_id: this.scheduleFilter.major_id,
        })
        this.countRP = this.statusRevenueSchedule[0].count_rp
        this.countRS = this.statusRevenueSchedule[0].count_rs
        if (this.countRP === 0) {
          showErrorToast(this, 'Chưa có kế hoạc thu của ngành trong học kỳ này')
        }
      }
    },
    resetRevenueSchedule() {
      this.$store.commit('revenueSchedule/SET_REVENUESCHEDULES', { total: 0, records: [] })
    },
    onEditRevenueSchedule(revenueSchedule) {
      const {
        rowNum,
        originalIndex,
        vgt_id,
        ...rest
      } = revenueSchedule
      this.currentRevenueSchedule = { ...this.currentRevenueSchedule, ...rest }
    },
    onDeleteRevenueSchedule(revenueSchedule) {
      this.$swal({
        title: `Bạn chắc chắn muốn xóa dự kiến thu <span class="text-danger">${revenueSchedule.revenue_name}</span>?`,
        text: 'Bạn sẽ không thể khôi phục lại dữ liệu này!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          try {
            const response = await this.deleteRevenueSchedule(revenueSchedule.id)
            if (response) {
              const { isSuccessful, message } = response
              if (isSuccessful) {
                showSuccessToast(this, message)
                await this.getRevenueSchedulesFromStore()
                this.countRS = 0
              } else {
                showErrorToast(this, message)
              }
            }
          } catch (e) {
            showErrorToast(this, e)
          } finally {
            this.isLoading = false
          }
        }
      })
    },
    onDeleteRevenueKTKSchedule(revenueSchedule) {
      this.$swal({
        title: `Bạn chắc chắn muốn xóa dự kiến thu khoản thu khác <span class="text-danger">${revenueSchedule.revenue_name}</span>?`,
        text: 'Bạn sẽ không thể khôi phục lại dữ liệu này!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          try {
            const response = await this.deleteRevenueKTKSchedule(revenueSchedule.id)
            if (response) {
              const { isSuccessful, message } = response
              if (isSuccessful) {
                showSuccessToast(this, message)
                await this.getRevenueSchedulesFromStore()
                this.countRS = 0
              } else {
                showErrorToast(this, message)
              }
            }
          } catch (e) {
            showErrorToast(this, e)
          } finally {
            this.isLoading = false
          }
        }
      })
    },
    updateScheduleParams(newProps) {
      this.scheduleFilter = { ...this.scheduleFilter, ...newProps }
    },
    async onSchedulePageChange(param) {
      this.updateScheduleParams({ currentPage: param.currentPage })
      await this.getRevenueSchedulesFromStore()
    },
    async getRevenueSchedulesFromStore() {
      this.isLoading = true
      try {
        await this.getRevenueSchedules(this.scheduleFilter)
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    async onSchedulePerPageChange(param) {
      this.updateScheduleParams({ currentPage: 1, itemsPerPage: param.currentPerPage })
      await this.getRevenueSchedulesFromStore()
    },
    async onRevenueScheduleSucceed() {
      await this.getRevenueSchedulesFromStore()
    },
    async onChildDataUpdated(componentType) {
      // Handle data update events from child components
      // Refresh related components when data changes
      await this.$nextTick()
      try {
        if (componentType === 'revenueType' && this.$refs.revenueRef) {
          // When revenue type is updated, refresh revenue component
          if (this.$refs.revenueRef.refreshData) {
            await this.$refs.revenueRef.refreshData()
          }
        } else if (componentType === 'revenue' && this.$refs.revenuePlanRef) {
          // When revenue is updated, refresh revenue plan component
          if (this.$refs.revenuePlanRef.refreshData) {
            await this.$refs.revenuePlanRef.refreshData()
          }
        }
        // Exemption and RevenueSchedule don't depend on other components
      } catch (e) {
        console.error('Error refreshing related components:', e)
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

/* Tab Switch Styles - giống Scheduler.vue */
.tab-switch {
  display: inline-flex;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  overflow: hidden;
  background: #f8f9fa;
}

.tab-btn {
  border: none;
  background: transparent;
  padding: 8px 16px;
  font-size: 0.9rem;
  color: #495057;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.tab-btn + .tab-btn {
  border-left: 1px solid #dee2e6;
}

.tab-btn.active {
  background: #1e90ff;
  color: #fff;
}

.tab-btn:hover:not(.active) {
  background: #e9ecef;
}

.tab-btn:focus {
  outline: none;
}

.mr-50 {
  margin-right: 0.5rem;
}

.my-tabs .nav-tabs,
.my-tabs .nav,
.my-tabs ul.nav-tabs,
.my-tabs ul.nav {
  display: none !important;
}

.my-tabs .nav-item,
.my-tabs .nav-link {
  display: none !important;
}

.my-tabs .tab-content {
  border: none !important;
  padding: 0 !important;
}

.p-50 {
  padding: 0.5rem !important;
}

.pb-25 {
  padding-bottom: 0.25rem !important;
}
</style>
